module.exports = __webpack_public_path__ + "img/alarmPoint.ad262c13.png";